<div
  *transloco="let t; prefix: 'property-listing.basic-information'"
  [formGroup]="basicInfoFormGroup"
  class="flex-1"
>
  <div class="flex flex-col rfs:gap-[72px]">
    <div class="flex flex-col gap-6">
      <h2 class="h2 text-black">
        {{ "property-listing.tabs.basicInformation" | transloco }}
      </h2>
    </div>

    <div class="flex flex-col gap-6">
      <h3 class="text-gray-950 font-semibold">
        {{ t("subheaders.propertyType") }}
      </h3>
      <div class="flex flex-row flex-wrap gap-4">
        <label class="visual-checkbox flex flex-col flex-1" for="villaCheckbox">
          <input
            (click)="
              basicInfoFormGroup.controls.type.setValue(propertyType.Villa)
            "
            [checked]="
              basicInfoFormGroup.controls.type.value == propertyType.Villa
            "
            class="opacity-0 absolute h-0 w-0"
            id="villaCheckbox"
            type="checkbox"
          />
          <i class="icon-villas text-[40px]"></i>
          <span class="">{{
            "shared.enum.propertyType." + propertyType.Villa | transloco
          }}</span>
        </label>

        <label
          class="visual-checkbox flex flex-col flex-1"
          for="apartmentCheckbox"
        >
          <input
            (click)="
              basicInfoFormGroup.controls.type.setValue(propertyType.Apartment)
            "
            [checked]="
              basicInfoFormGroup.controls.type.value == propertyType.Apartment
            "
            class="opacity-0 absolute h-0 w-0"
            id="apartmentCheckbox"
            type="checkbox"
          />
          <i class="icon-apartment text-[40px]"></i>
          <span class="">{{
            "shared.enum.propertyType." + propertyType.Apartment | transloco
          }}</span>
        </label>

        <label
          class="visual-checkbox flex flex-col flex-1"
          for="maisonetteCheckbox"
        >
          <input
            (click)="
              basicInfoFormGroup.controls.type.setValue(propertyType.Maisonette)
            "
            [checked]="
              basicInfoFormGroup.controls.type.value == propertyType.Maisonette
            "
            class="opacity-0 absolute h-0 w-0"
            id="maisonetteCheckbox"
            type="checkbox"
          />
          <i class="icon-maisonette text-[40px]"></i>
          <span class="">{{
            "shared.enum.propertyType." + propertyType.Maisonette | transloco
          }}</span>
        </label>

        <label
          class="visual-checkbox flex flex-col flex-1"
          for="holidayHomeCheckbox"
        >
          <input
            (click)="basicInfoFormGroup.controls.type.setValue(propertyType.CountryHouse)"
            [checked]="basicInfoFormGroup.controls.type.value == propertyType.CountryHouse"
            class="opacity-0 absolute h-0 w-0"
            id="holidayHomeCheckbox"
            type="checkbox"
          />
          <i class="icon-country-house text-[40px]"></i>
          <span class="">{{
            "shared.enum.propertyType.CountryHouse" | transloco
          }}</span>
        </label>
      </div>
    </div>

    <form id="property-wizard">
      <fieldset class="flex flex-col gap-6 group/input rfs:mb-[72px]">
        <label class="font-semibold text-gray-950 group-disabled:text-gray-300"
          >{{'property-details.detail-section.titles.constructionYear' | transloco}}</label
        >
        <input
          #year
          placeholder="1970"
          type="number"
          [value]="basicInfoFormGroup.controls.constructionYear.value"
          (input)="constructionYearChanged(year)"
          class="bg-white max-w-[216px] text-gray-500 rounded-full border border-gray-300 py-3 px-4 group-focus-within/input:border-[1.5px] group-focus-within/input:text-gray-900 group-focus-within/input:border-primary-500 transition-colors duration-300 outline-none"
        />
      </fieldset>
      <fieldset class="flex flex-col gap-8 group/input">
        <label
          class="font-semibold flex gap-2 items-center text-gray-950 group-disabled:text-gray-300"
        >
          {{ t("labels.area") }}
          <i class="icon-info-circle text-xl text-gray-900"></i>
        </label>
        <div class="flex flex-col lg:flex-row gap-8 items-center w-full">
          <div class="flex-1 w-full">
            <ngx-slider
              (userChange)="onAreaSliderChange($event)"
              [(value)]="area"
              [options]="areaSliderOptions"
            ></ngx-slider>
          </div>
          <div
            class="flex-1 w-full justify-between flex max-w-[150px] bg-white text-gray-500 rounded-full border border-gray-300 py-3 px-4 group-focus-within/input:border-[1.5px] group-focus-within/input:text-gray-900 group-focus-within/input:border-primary-500 transition-colors duration-300 outline-none"
          >
            <input
              class="outline-none max-w-[50px]"
              formControlName="area"
              max="800"
              min="20"
              (change)="area = basicInfoFormGroup.controls['area'].value"
              placeholder="122"
              type="number"
            />
            <span class="text-gray-900 font-semibold">m²</span>
          </div>
        </div>
      </fieldset>
    </form>

    <ng-container
      [ngTemplateOutlet]="!editPrices ? prices : editPrices"
    ></ng-container>

    <div class="flex flex-col gap-6">
      <h3 class="text-black font-semibold">{{ t("subheaders.address") }}</h3>
      <div class="flex flex-col gap-8">
        <div class="w-full">
          <app-google-maps-search-autocomplete
            #addressSearch
            [defaultValue]="addressName"
            (onItemSelected)="onPlaceSelected($event)"
            [alternativeStyle]="true"
            [placeHolder]="t('placeholders.address')"
            [types]="['address']"
          ></app-google-maps-search-autocomplete>
          <!--                    <form id="property-wizard-location" [formGroup]="basicInfoFormGroup.controls.address">-->
          <!--                        <div class="flex flex-col gap-4">-->
          <!--                            <fieldset class="flex flex-col gap-2 group/input">-->
          <!--                                <label-->
          <!--                                    class="font-semibold flex items-center justify-between text-gray-950 group-disabled:text-gray-300">{{t('labels.streetName')}}</label>-->
          <!--                                <input [placeholder]="t('labels.streetName')"-->
          <!--                                    class="bg-white text-gray-500 rounded-full border border-gray-300 py-3 px-4 group-focus-within/input:border-[1.5px] group-focus-within/input:text-gray-900 group-focus-within/input:border-primary-500 transition-colors duration-300 outline-none"-->
          <!--                                    [readonly]="true" formControlName="streetName">-->
          <!--                            </fieldset>-->
          <!--                            <div class="flex flex-col md:flex-row justify-between gap-4">-->
          <!--                                <fieldset class="flex flex-col gap-2 group/input">-->
          <!--                                    <label-->
          <!--                                        class="font-semibold flex items-center justify-between text-gray-950 group-disabled:text-gray-300">{{t('labels.streetNumber')}}</label>-->
          <!--                                    <input [placeholder]="t('labels.streetNumber')"-->
          <!--                                        class="bg-white text-gray-500 rounded-full border border-gray-300 py-3 px-4 group-focus-within/input:border-[1.5px] group-focus-within/input:text-gray-900 group-focus-within/input:border-primary-500 transition-colors duration-300 outline-none"-->
          <!--                                        [readOnly]="true" formControlName="streetNumber">-->
          <!--                                </fieldset>-->
          <!--                                <fieldset class="flex flex-col gap-2 group/input">-->
          <!--                                    <label-->
          <!--                                        class="font-semibold flex items-center justify-between text-gray-950 group-disabled:text-gray-300">{{t('labels.zipCode')}}</label>-->
          <!--                                    <input [placeholder]="t('labels.zipCode')"-->
          <!--                                        class="md:max-w-[184px] bg-white text-gray-500 rounded-full border border-gray-300 py-3 px-4 group-focus-within/input:border-[1.5px] group-focus-within/input:text-gray-900 group-focus-within/input:border-primary-500 transition-colors duration-300 outline-none"-->
          <!--                                        [readOnly]="true" formControlName="postalCode">-->
          <!--                                </fieldset>-->
          <!--                            </div>-->
          <!--                            <fieldset class="flex flex-col gap-2 group/input">-->
          <!--                                <label-->
          <!--                                    class="font-semibold flex items-center text-gray-950 group-disabled:text-gray-300 gap-2">{{t('labels.municipality')}}-->
          <!--                                    <i class="icon-info-circle text-xl text-gray-900"></i>-->
          <!--                                </label>-->
          <!--                                <input [placeholder]="t('labels.municipality')"-->
          <!--                                    class="bg-white text-gray-500 rounded-full border border-gray-300 py-3 px-4 group-focus-within/input:border-[1.5px] group-focus-within/input:text-gray-900 group-focus-within/input:border-primary-500 transition-colors duration-300 outline-none"-->
          <!--                                    [readOnly]="true" formControlName="prefecture">-->
          <!--                            </fieldset>-->
          <!--                        </div>-->
          <!--                    </form>-->
        </div>
        <div
          #gMapContainer
          *ngIf="basicInfoFormGroup.controls.address.get('geoPoint')?.value"
          class="w-full h-full border-4 overflow-hidden border-white rounded-lg"
        >
          <google-map
            #propertyMap
            [mapId]="'2ee4cac2a3e9c60'"
            [options]="mapOptions"
            [width]="gMapContainer.clientWidth"
          >
            <map-marker
              *ngFor="let marker of markers$ | async"
              [icon]="marker.icon"
              [position]="marker.position"
              class="text-white"
            >
            </map-marker>
          </google-map>
        </div>
      </div>
    </div>

    <!--        <app-advisor-callback [advisor]="advisor"></app-advisor-callback>-->

    <!--        <div class="border-t-2 pt-7 flex justify-end">-->
    <!--            <button class="text-secondary-900 flex items-center gap-2 font-semibold hover:text-success transition-color"-->
    <!--                (click)="onNext()">-->
    <!--                {{'property-listing.tabs.titleAndDescription' | transloco}}-->
    <!--                <i class="icon-arrow-right text-lg"></i>-->
    <!--            </button>-->
    <!--        </div>-->
  </div>
</div>

<ng-template #prices>
  <div
    *transloco="let t; prefix: 'property-listing.basic-information'"
    class="bg-gray-100 rounded-lg flex flex-col gap-5 p-6"
  >
    <div
      (click)="showPrices = true"
      class="font-semibold text-gray-900 flex justify-between"
    >
      <span>{{ t("infoText.askingPriceBetween") }}</span>
      <button
        class="text-secondary-900 font-semibold flex items-end gap-1 leading-none"
      >
        <i class="icon-edit text-lg"></i>{{ t("buttons.edit") }}
      </button>
    </div>
    <div class="text-gray-700">
      <span class="text-black rfs:text-[2rem] leading-none font-semibold"
        >€{{ basicInfoFormGroup.controls.lowestPrice.value }} – €{{
          basicInfoFormGroup.controls.askingPrice.value
        }}</span
      >
      {{
        basicInfoFormGroup.controls.area.value
          ? "minimum " +
            (basicInfoFormGroup.controls.lowestPrice.value /
              basicInfoFormGroup.controls.area.value | number: "1.0-2") +
            (" " + t("infoText.perSqM"))
          : ""
      }}
    </div>
    <div class="text-gray-700">
      {{ t("infoText.priceWithinRecentClosingRange") }}
    </div>
  </div>
</ng-template>

<ng-template #editPrices [formGroup]="basicInfoFormGroup">
  <ng-container
    *transloco="let t; prefix: 'property-listing.basic-information'"
  >
    <fieldset class="flex flex-col gap-8 group/input">
      <label
        class="font-semibold flex gap-2 items-center text-gray-950 group-disabled:text-gray-300"
      >
        {{ t("subheaders.price") }}
        <i class="icon-info-circle text-xl text-gray-900"></i>
      </label>
      <div class="flex flex-col lg:flex-row gap-8 items-center w-full">
        <div class="flex-1 w-full">
          <ngx-slider
            (userChange)="onPriceSliderChange($event)"
            [(value)]="this.maxPrice"
            [options]="priceSliderOptions"
          ></ngx-slider>
        </div>
        <div
          class="flex-1 w-full justify-between flex gap-3 max-w-[150px] bg-white text-gray-500 rounded-full border border-gray-300 py-3 px-4 group-focus-within/input:border-[1.5px] group-focus-within/input:text-gray-900 group-focus-within/input:border-primary-500 transition-colors duration-300 outline-none"
        >
        <span class="inset-y-0 left-5 flex items-center pl-2 text-gray-900">€</span>
          <input
            mask="separator"
            thousandSeparator="."
            [(value)]="this.formattedPrice"
            (change)="onPriceAdjust()"
            class="outline-none max-w-[80px] flex-1"
            formControlName="askingPrice"
            max="2000000"
            min="20000"
            type="text"
          />
        </div>
      </div>
    </fieldset>
  </ng-container>
</ng-template>
